import React, { useContext } from 'react';
import { Header } from '@amzn/awsui-components-react-v3';
import { SpotcpInfo, InfoLink } from './info';
import { StateContext } from './context/spotcp-context';

import '../../styles/spotcp.css';

export const SpotcpHeader = (props) => {
  const { requestSubmitted, request } = useContext(StateContext);

  return (
    <Header
      variant="h1"
      description={request ? request.timeFrameLabel : ''}
      info={<InfoLink onFollow={() => props.updateTools(<SpotcpInfo />)} />}
    >
      SPOT CP Accuracy
    </Header>
  );
};



// WEBPACK FOOTER //
// ./src/components/spotcp/header.jsx